import { module as BaseModule } from "modujs"
import Gallery from "./SingleProduct/Gallery"
import SimpleProduct from "./SingleProduct/SimpleProduct"
import VariationProduct from "./SingleProduct/VariationProduct"

export default class extends BaseModule {
  init() {
    this.gallery = new Gallery(this.el)

    if (this.el.querySelector("[data-variation-product-form]")) {
      this.variationProduct = new VariationProduct(this.el)
    } else {
      this.simpleProduct = new SimpleProduct(this.el)
    }

    this.setQuantity()
  }

  setQuantity() {
    const decreaseButtons = this.el.querySelectorAll("button[data-qty-decrease]")
    const increaseButtons = this.el.querySelectorAll("button[data-qty-increase]")
    const quantityDisplay = this.el.querySelector("[data-qty-display]")
    const quantityInput = this.el.querySelector("[data-qty-input]")

    if (!quantityDisplay || !quantityInput) {
      return
    }

    const parseBound = (attr, fallback) => {
      const value = parseInt(quantityInput.getAttribute(attr), 10)
      return Number.isNaN(value) ? fallback : value
    }

    const min = parseBound("min", 1)
    const max = parseBound("max", Infinity)

    let currentValue = parseInt(quantityInput.value, 10)
    if (Number.isNaN(currentValue) || currentValue < min) {
      currentValue = min
    } else if (currentValue > max) {
      currentValue = max
    }

    const updateQuantity = (value) => {
      const clampedValue = Math.max(min, Math.min(max, value))
      currentValue = clampedValue
      quantityInput.value = clampedValue
      quantityDisplay.textContent = clampedValue
    }

    updateQuantity(currentValue)

    decreaseButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault()
        updateQuantity(currentValue - 1)
      })
    })

    increaseButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault()
        updateQuantity(currentValue + 1)
      })
    })
  }
}
